var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/DeleteFilled.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
export const DeleteFilled = ({
  color = '#353B60',
  opacity = '1',
  ...other
}) => /*#__PURE__*/_jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: /*#__PURE__*/_jsx("path", {
    d: "M12.0834 2.5H7.91669L7.08335 3.33333H5.00002C4.53978 3.33333 4.16669 3.70643 4.16669 4.16667C4.16669 4.6269 4.53978 5 5.00002 5H15C15.4603 5 15.8334 4.6269 15.8334 4.16667C15.8334 3.70643 15.4603 3.33333 15 3.33333H12.9167L12.0834 2.5ZM15 5.83333H5.00002V15.8333C5.00002 16.75 5.75002 17.5 6.66669 17.5H13.3334C14.25 17.5 15 16.75 15 15.8333V5.83333Z",
    fill: color,
    opacity: opacity
  })
});